var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { attrs: { for: _vm.forElement, tabindex: _vm.useTabindex ? 0 : -1 } },
    [
      _vm._v(
        "    \n  " +
          _vm._s(
            _vm.titleParams && _vm.titleParams.length > 0
              ? _vm.$t(_vm.title, null, _vm.titleParams)
              : _vm.$t(_vm.title)
          ) +
          "\n  "
      ),
      _vm.required
        ? _c("i", { staticClass: "fas fa-asterisk icon red" }, [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.$t("Icon.Required")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.instructionKey && !_vm.srOnly
        ? _c("tooltip-icon", { attrs: { content: _vm.$t(_vm.instructionKey) } })
        : _vm.instructionKey && _vm.srOnly
        ? _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.$t(_vm.instructionKey)))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }